import { z } from 'zod';
import { bovedaSchema } from './boveda';
import { centavos, centavosPositivos, dia, textoRequerido, uuid } from './comunes';

export const TIPOS_MARCA = ['llegada', 'comida_inicio', 'comida_fin', 'salida'] as const;
export type TipoMarca = (typeof TIPOS_MARCA)[number];

export const marcarAsistenciaSchema = z.object({ tipo: z.enum(TIPOS_MARCA), usuarioId: uuid.optional() });
export const permisoAsistenciaSchema = z.object({ usuarioId: uuid, dia, nota: textoRequerido(300) });

export interface RegistroDia {
  dia: string;
  horario: { entrada: string; salida: string; comidaInicio: string | null; comidaFin: string | null; esDescanso: boolean } | null;
  llegada: string | null;
  comidaInicio: string | null;
  comidaFin: string | null;
  salida: string | null;
  permiso: boolean;
  notaPermiso: string | null;
  retardoMin: number;
  minutosProgramados: number;
  minutosTrabajados: number;
  extraMin: number;
  faltanteMin: number;
  falta: boolean;
}

export interface AsistenciaSemana {
  semana: string;
  dias: string[];
  personas: { id: string; nombre: string; registros: RegistroDia[] }[];
}

export const pagarNominaSchema = z.object({
  /** De qué bóveda sale el pago. */
  boveda: bovedaSchema,
  semana: dia,
  usuarioId: uuid,
  faltantes: z.array(z.object({ id: uuid, accion: z.enum(['descontar', 'perdonar']) })).default([]),
  ajustes: centavos.default(0),
  nota: z.string().trim().max(300).optional(),
});
export type PagarNominaInput = z.infer<typeof pagarNominaSchema>;

export interface FaltantePendiente {
  id: string;
  fecha: string;
  monto: number;
  moneda: 'MXN' | 'USD';
  montoMXN: number;
}

export interface NominaPersona {
  usuario: { id: string; nombre: string; rol: string };
  sueldoSemanal: number | null;
  minutosProgramados: number;
  minutosTrabajados: number;
  retardos: number;
  faltas: number;
  servicios: number;
  comisionServicios: number;
  comisionProductos: number;
  propinasDirectas: number;
  propinasReparto: number;
  faltantesPendientes: FaltantePendiente[];
  calculo: {
    sueldoBase: number;
    ajusteTiempo: number;
    comisionServicios: number;
    comisionProductos: number;
    propinas: number;
    descuentoFaltantes: number;
    ajustesManuales: number;
    total: number;
  };
  pagado: { id: string; total: number; pagadoEn: string; pagadoPor: string | null } | null;
}

export interface NominaSemana {
  semana: string;
  hasta: string;
  personas: NominaPersona[];
}

